import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Chart } from 'react-google-charts';

const GanttChart = (props: any) => {
  const [chartData, setChartData] = useState<any>();
  const [height, setHeight] = useState<number>(680);

  useEffect(() => {
    let data = [
      [
          { type: 'string', label: 'Task ID' },
          { type: 'string', label: 'Task Name' },
          { type: 'string', label: 'Resource' },
          { type: 'date', label: 'Start Date' },
          { type: 'date', label: 'End Date' },
          { type: 'number', label: 'Duration' },
          { type: 'number', label: 'Percent Complete' },
          { type: 'string', label: 'Dependencies' },
      ]
    ];

    for(let i = props.data.length - 1; i >= 0; --i) {
      let taskId = props.data[i].serial.toString();
      let task = props.data[i].process + ' - ' + props.data[i].inputCode;
      let owner = props.data[i].owner;
      let sDate = dayjs(props.data[i].plannedStartDate);
      let startDate = new Date(sDate.year(), sDate.month(), sDate.date());
      let eDate = dayjs(props.data[i].plannedEndDate);
      let endDate = new Date(eDate.year(), eDate.month(), eDate.date());
      let duration = null;
      let daysCompleted = dayjs().diff(sDate, 'day');
      let daysLeft = eDate.diff(sDate, 'day');
      let completion = daysCompleted < 0 ? 0 : daysCompleted * 100 / daysLeft;
      completion = completion > 100 ? 100 : completion;
      let dependency = 'NA' === props.data[i].dependency ? null : props.data[i].dependency;
      data.push([taskId, task, owner, startDate, endDate, duration, completion.toFixed(0), dependency]);
    }
    setChartData(data);
    let height = 210 + (props.data.length - 5) * 30;
    setHeight(height > 680 ? 680 : height);
  }, []);

  const options = {
    height: height,
    gantt: {
      criticalPathEnabled: false,
      innerGridHorizLine: {
        stroke: "#ffe0b2",
        strokeWidth: 1,
      },
      //innerGridTrack: { fill: "#fff3e0" },
      //innerGridDarkTrack: { fill: "#ffcc80" },
      arrow: {
        angle: 60,
        width: 3,
        color: 'green',
        radius: 10
      },
      trackHeight: 30,
      labelStyle: {
        fontSize: 18
      },
    },
  };

  return (
    <div style={{ fontFamily: 'sans-serif !important'}}>
      <Chart chartType="Gantt" width="1400px" data={chartData} options={options}/>
    </div>
  );
}

export default GanttChart;